import axios from 'axios'
const APP_ID = '4i6DFMof3BCiqCiun3xm'
const APP_CODE = 'TSyvE5yaGmjkOo4LtaANVw'

export const getCoordinatesFromLocationNameMixin = {
  methods: {
    async getCoordinatesFromLocationName (locationName) {
      const BASE_URL = 'https://geocoder.api.here.com/6.2/geocode.json'

      const {
        data
      } = await axios
        .get(`${BASE_URL}?app_id=${APP_ID}&app_code=${APP_CODE}&searchtext=${locationName}`)

      if (!data.Response.View || data.Response.View.length === 0) {
        throw new Error('Informações de Endereço Inválidas')
      }

      const coordinates = await data.Response.View[0].Result[0].Location.DisplayPosition
      return coordinates
    }
  }
}

export const getLocationNameFromCoordinatesMixin = {
  methods: {
    async getLocationNameFromCoordinates (coordinates) {
      const { lat, lng } = coordinates
      const BASE_URL = 'https://reverse.geocoder.api.here.com/6.2/reversegeocode.json'
      try {
        const {
          data
        } = await axios
          .get(`${BASE_URL}?app_id=${APP_ID}&app_code=${APP_CODE}&prox=${lat},${lng}&mode=retrieveAreas`)
        if (!data.Response.View || data.Response.View.length === 0) {
          throw new Error('Informações de Endereço Inválidas')
        }
        const Address = await data.Response.View[0].Result[0].Location.Address
        const city = Address.City
        const state = Address.State
        const country = Address.AdditionalData.find(data => data.key === 'CountryName').value

        return await `${city}, ${state}, ${country}`
      } catch (err) {
        console.log(err)
      }
    }
  }
}
